// API endpoints for production

export const USER_API_END_POINT="https://www.hirees.com/api/v1/user";
export const JOB_API_END_POINT="https://www.hirees.com/api/v1/job";
export const APPLICATION_API_END_POINT="https://www.hirees.com/api/v1/application";
export const COMPANY_API_END_POINT="https://www.hirees.com/api/v1/company";
export const SAVED_JOBS_API_END_POINT="https://www.hirees.com/api/v1/savedjobs";
export const FEEDBACK_API_END_POINT = "https://www.hirees.com/api/v1/feedback";
export const RESUME_API_END_POINT = "https://www.hirees.com/api/v1/bulk-resume";

// for local development, you can use the following endpoints: 

// export const USER_API_END_POINT = "http://localhost:8000/api/v1/user";
// export const JOB_API_END_POINT="http://localhost:8000/api/v1/job"; 
// export const APPLICATION_API_END_POINT="http://localhost:8000/api/v1/application"; 
// export const COMPANY_API_END_POINT="http://localhost:8000/api/v1/company";
// export const SAVED_JOBS_API_END_POINT="http://localhost:8000/api/v1/savedjobs";
// export const FEEDBACK_API_END_POINT = "http://localhost:8000/api/v1/feedback";
// export const RESUME_API_END_POINT = "http://localhost:8000/api/bulk-resume"; 


// const BASE_URL = import.meta.env.VITE_API_BASE_URL;

// export const USER_API_END_POINT = `${BASE_URL}/api/v1/user`;
// export const JOB_API_END_POINT = `${BASE_URL}/api/v1/job`;
// export const APPLICATION_API_END_POINT = `${BASE_URL}/api/v1/application`;
// export const COMPANY_API_END_POINT = `${BASE_URL}/api/v1/company`;
// export const SAVED_JOBS_API_END_POINT = `${BASE_URL}/api/v1/savedjobs`;
